import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { NzModalService } from 'ng-zorro-antd/modal';

import { TranslateService } from '@ngx-translate/core';

import { lastValue } from '@app/shared/operators/last-value.operator';

@Injectable()
export class HttpErrorDialogInterceptor implements HttpInterceptor {
  constructor(
    private ms: NzModalService,
    private ts: TranslateService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const code = error.status ?? error.error?.status;

        if (code === 409) {
          let nzTitle: string;
          let nzContent: string;

          if (/\/customers\/[0-9]+\/performance-groups/.test(req.url)) {
            nzTitle = 'common.account-move.change-submission-disabled-title';
            nzContent = 'common.account-move.change-submission-disabled-content';
          }

          if (nzTitle && nzContent) {
            this.ms.error({
              nzTitle: lastValue(this.ts.get(nzTitle)),
              nzContent: lastValue(this.ts.get(nzContent)),
              nzClosable: false,
              nzOkText: lastValue(this.ts.get('common.ok')),
              nzClassName: 'a-modal-small',
            });
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
